import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Background from '../Background/Background';
import WhyUs from '../WhyUs/WhyUs';
import MostVisit from '../MostVisit/MostVisit';
import HomeGallery from '../Gallery/HomeGallery';
import CustomerReview from '../CustomerReview/CustomerReview';
import WhatsappButton from '../WhatsappButton/WhatsappButton';
import About from '../About/About';

const Home = () => {
  const [showScroll, setShowScroll] = useState(false);

  // Handle Scroll to Top Visibility
  useEffect(() => {
    const checkScroll = () => {
      if (!showScroll && window.pageYOffset > 400) {
        setShowScroll(true);
      } else if (showScroll && window.pageYOffset <= 400) {
        setShowScroll(false);
      }
    };
    window.addEventListener('scroll', checkScroll);
    return () => window.removeEventListener('scroll', checkScroll);
  }, [showScroll]);

  // Optimized Structured Data
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "CarRental",
    "name": "Shree Ram Car Rental",
    "url": "https://shreeramcarrental.com",
    "logo": "https://shreeramcarrental.com/logo192.png",
    "description": "Premium 24/7 self-drive car rental in Indore. Book Thar, Fortuner, and luxury cars at affordable daily rates with doorstep delivery.",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Shop No 1, Bhavna Nagar, Sapna Sangeeta Rd, Limbodi",
      "addressLocality": "Indore",
      "addressRegion": "Madhya Pradesh",
      "postalCode": "452001",
      "addressCountry": "IN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "22.7196",
      "longitude": "75.8577"
    },
    "telephone": "+919755357721",
    "priceRange": "₹1400 - ₹35000",
    "openingHours": "Mo-Su 00:00-23:59",
    "sameAs": [
      "https://www.instagram.com/shreeramcarrentalndore/",
      "https://wa.me/919755357721"
    ]
  };

  return (
    <>
      <Helmet>
        {/* Browser Tab Title */}
        <title>Shree Ram Car Rental | #1 Self Drive Cars in Indore</title>
        
        {/* SEO Meta Tags */}
        <meta name="description" content="Rent self drive cars in Indore starting at ₹1400. Choose from Thar, Fortuner, Creta & more. 24/7 doorstep delivery and showroom-maintained fleet. Book now!" />
        <meta name="keywords" content="self drive car rental indore, rent thar in indore, fortuner rental indore, luxury car hire indore, car rental service indore, shree ram car rental" />
        <link rel="canonical" href="https://shreeramcarrental.com" />
        
        {/* Open Graph / Social Media */}
        <meta property="og:title" content="Shree Ram Car Rental | Best Self Drive Cars in Indore" />
        <meta property="og:description" content="Premium 24/7 self-drive car rental in Indore. Best prices for Thar, Fortuner & Luxury cars." />
        <meta property="og:image" content="https://shreeramcarrental.com/logo192.png" />
        <meta property="og:url" content="https://shreeramcarrental.com" />

        {/* JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      <main className="home-container">
        {/* Hero Section */}
        <section id="hero" aria-label="Welcome">
          <Background />
        </section>
        
        {/* Temple Tours / Destinations */}
        <section id="tours" className="section-padding" aria-label="Destinations">
          <MostVisit />
        </section>

        {/* About Section */}
        <section id="about" className="section-padding" aria-label="About Us">
          <About/>
        </section>

        {/* Fleet Gallery */}
        <section id="fleet" className="section-padding" aria-label="Our Fleet">
          <HomeGallery />
        </section>

        {/* Features / Why Us */}
        <section id="features" className="section-padding" aria-label="Why Choose Us">
          <WhyUs />
        </section>
        
        {/* Testimonials */}
        <section id="reviews" className="section-padding" aria-label="Customer Reviews">
          <CustomerReview />
        </section>

        {/* Sticky Components */}
        <WhatsappButton />

        {/* Scroll to Top Button (Hidden until scroll) */}
        {showScroll && (
          <button 
            className="scroll-to-top visible" 
            aria-label="Scroll to top" 
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            ↑
          </button>
        )}
      </main>
    </>
  )
}

export default Home;